import styled from 'styled-components';

export const DownloadButtonContainer = styled.button`
    display: flex;
    align-items: center;
    width: 215px;
    padding: 10px 25px;
    border-radius: 27px;
    border: none;
    color: ${props => props.theme.white};
    text-align: left;
    cursor: pointer;

    .isvg {
        display: flex;
        align-items: center;
        position: relative;
        top: -1px;
        svg {
            height: 24px;
            width: auto;
        }
    }

    & > div {
        margin-left: 20px;
        font-size: 12px;

        span {
            font-size: 18px;
        }
    }

    &.inverted {
        padding: 7px 0;
        justify-content: center;
        background: transparent !important;
        border: 1px solid ${props => props.theme.white};

        & > div {
            margin-left: 10px;
            font-size: 10px;

            span {
                font-size: 14px;
            }
        }

        &:hover {
            text-decoration: underline;
        }
    }

    &.google {
        background: ${props => props.theme.primary};
        &:hover {
            background: lighten(${props => props.theme.primary}, 2.5%);
        }
    }

    &.apple {
        background: ${props => props.theme.primary};
        &:hover {
            background: lighten(${props => props.theme.primary}, 2.5%);
        }
    }
`;



// WEBPACK FOOTER //
// ./src/components/button/DownloadButtonStyle.js